module.exports = __webpack_public_path__ + "static/media/TheHistoriaDemo-01.efa7c8b3.svg";